module.exports = __webpack_public_path__ + "media/application/images/link-fdc597a7360cccab4e7b2171bc28ecb2.svg";